import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { createNumberMask } from 'redux-form-input-masks';
import { required } from 'redux-form-validators';
import { BodyText, TextInput } from '@swift-paypal/pp-react';
import constants from '../../../../constants';

// eslint-disable-next-line react/prop-types
const MappedInput = ({ input, ...props }) => <TextInput {...input} {...props} />;

const currencyMask = createNumberMask({
  allowEmpty: true,
  prefix: '$',
  decimalPlaces: 2,
  locale: 'en-US',
});

const { errors } = constants;

const UtilityPayments = ({
  className, error, submitted, touched, value,
}) => (
  <>
    <BodyText as="label" htmlFor="utilityPayments">
      Business utility payments
    </BodyText>
    <Field
      className={className}
      key="utility-payments"
      name="utilityPayments"
      errorText={submitted || touched ? error : undefined}
      component={MappedInput}
      placeholder="$"
      value={value}
      validate={[required({ msg: errors.currencyZeroError })]}
      {...currencyMask}
    />
  </>
);

UtilityPayments.defaultProps = {
  className: undefined,
  error: undefined,
  submitted: false,
  touched: false,
  value: undefined,
};

UtilityPayments.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  submitted: PropTypes.bool,
  touched: PropTypes.bool,
  value: PropTypes.number,
};

export default memo(UtilityPayments);
